package horcrux.frontend.common.views.chat

import horcrux.frontend.common.views.components.containers.VStack
import mui.material.CircularProgress
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import web.cssom.FontFamily
import web.cssom.pt

external interface LoadingMessageProps : PropsWithSx

val LoadingMessage = FC<LoadingMessageProps> { props ->
    VStack {
        this.sx { +props.sx }
        Typography {
            +"Sending Your Message"
            this.variant = TypographyVariant.h6
            this.sx {
                this.fontFamily = FontFamily.sansSerif
                this.marginRight = 10.pt
            }
        }
        CircularProgress {}
    }
}
